export default "__VITE_ASSET__De5pN6pG__"